export const RESTRICTED_MODULES = {
  telemedicine: {
    allowedRoles: ['admin', 'medico', 'superadmin'],
  },
  surgery: {
    allowedRoles: ['admin', 'superadmin', 'quirofano'],
  },
  cameras: {
    allowedRoles: ['admin', 'superadmin', 'seguridad'],
  },
  tenant_management: {
    allowedRoles: ['owner', 'admin', 'tenant_admin', 'superadmin', 'platform_admin'],
  },
};

export function canAccessModule(user, moduleId, tenantConfig) {
  const moduleConfig = tenantConfig?.modules?.[moduleId];
  const isInternal = moduleConfig?.internal === true;

  if (isInternal && !user) {
    return false;
  }

  if (RESTRICTED_MODULES[moduleId]) {
    if (!user) return false;
    const userTenantId = user.tenantId || user.tenant_id || null;
    if (userTenantId && tenantConfig?.id && userTenantId !== tenantConfig.id) {
      return false;
    }
    const userRoles = Array.isArray(user.roles)
      ? user.roles.filter(Boolean)
      : [user.role].filter(Boolean);
    const allowedRoles = RESTRICTED_MODULES[moduleId].allowedRoles;
    if (!userRoles.some(role => allowedRoles.includes(role))) {
      return false;
    }
  }

  return true;
}
